
//import './main-header.html';
import MainHeaderController from './main-header.controller';

const MainHeaderComponent = {
  bindings: {},
  template: require('./main-header.html'),
  controller: MainHeaderController
};


export default MainHeaderComponent;



// WEBPACK FOOTER //
// ./client/app/layout/main-layout/main-header/main-header.component.js